export default __webpack_public_path__ + "static/media/product-wash-arms.115689cd.svg";